import React, {Component} from 'react';

import axios from 'axios'
import {connect} from 'react-redux'
import {locale} from '../locale/AppLocale'
import Config from '../Helpers/Config'
import { Tooltip as ReactTooltip } from 'react-tooltip'
import Loader from '../Components/Loader'
import DropZone from '../Components/DropZone'
import Breadcrumb from '../Components/Breadcrumb'
import ProductInput from '../Components/ProductInput'
import {push as routerPush} from 'react-router-redux'
import {NotificationManager} from '../Helpers/NotificationManager';
import {ValidateProduct,validateSellingProps, validatePrimarySellingProps,  publishErrors} from '../Helpers/ValidateProduct'
import {CartesianProduct} from "../Helpers/CartesianProduct"
import * as productFormActions from "../actions/productFormActions"
import WithoutVariantFields from '../Components/WithoutVariantFields'
import ProductAttributesWizard from "../Components/ProductAttributesWizard"
import * as authActions from '../actions/authActions'

import PiecesModal from '../Components/PiecesModal';


import {
    Field,
    FieldArray,
    reduxForm,
    formValueSelector,
    arrayRemoveAll,
    arrayPush,
    touch as touchForm,
    stopAsyncValidation,
    getFormValues,
    getFormSyncErrors as formErrors,
} from 'redux-form';

const formValidation = (values,props) => {

    let sellingErrors = {};

    if(props.initialValues.variantsIndexes.length === 0){
        sellingErrors = validateSellingProps(values, props);
    }else{
        sellingErrors = validatePrimarySellingProps(values, props);
    }

    return {
        ...ValidateProduct(values, props),
        ...sellingErrors
    }
};

import {flattenObject} from '../Helpers/flattenObject'
import {FixFormValues} from "../Helpers/FixFormValues";
import {GetEntityAttribute} from "../Helpers/Entity";

const formName = 'productForm';
const selector = formValueSelector(formName);

class Product extends Component {

    constructor(props){
        super(props);
        this.state = {
            requiresPiecesUpdate:false,
            piecesPrice:0
        };
        this.onSubmitPieces = this.onSubmitPieces.bind(this);
        this.onRefusePieces = this.onRefusePieces.bind(this);
    }

    componentDidMount() {
        this.props.fetchProductForm(this.props.match.params.categoryId);
    }

    onSubmitPieces(prices){
        let values = this.props.formValues;
        values = this.getValues(values);
        if(values.variants && values.variants.length){
            prices.forEach((item) => {
                if(!values.variants[item.index]){
                    return;
                }
                values.variants[item.index].price = item.price;
                values.variants[item.index].pieces = item.pieces;
            })
        }else{
            values.pieces = prices[0].pieces;
            values.price = prices[0].price;
        }

        this.props.toggleFormActionStatus(true);
        this.sendCreateRequest(values);
    }

    onRefusePieces(){
        let values = this.props.formValues;
        values = this.getValues(values);
        this.props.toggleFormActionStatus(true);
        this.sendCreateRequest(values);
    }


    getValues(values){

        
        if (this.props.dirty === false) {
            NotificationManager.warning(locale.get('you_did_not_change_values_to_create_product'));
            return;
        }

        let data = {
            title_ar: GetEntityAttribute(values,'title'),
            description_ar: GetEntityAttribute(values,'description'),
            images: values.images || [],
            variants: []
        };
        values.variants = values.variants || [];

        this.props.productSpecs.attributes.forEach((group, index) => {
            group.properties.forEach((field, index) => {
                if (typeof values[field.name] === 'undefined') {
                    return ;
                } else {
                    data[field.name] = values[field.name];
                    if (field.data_type === 'dropdown') {
                        if (field.has_other && values[field.name] === -1) {
                            data[field.name + '_other'] = values[field.name + '_other'];
                        } else if (field.is_variant) {
                            data[field.name] = values[field.name].map(function (value) {
                                return value.value;
                            });
                        } else {
                            data[field.name] = values[field.name];
                        }
                    }

                }
            });
        });

        data.variants = values.variants.map((variant) => {
            let v = {
                price: variant.price,
                old_price: variant.old_price || 0,
                is_active: variant.is_active,
                sku: variant.sku,
                barcode: variant.barcode,
                quantity: variant.quantity,
                items: variant.items.map((item) => {
                    return {
                        property_id: item.id,
                        group_id: item.group_id,
                        attribute_id: item.attribute_id,
                        title_ar: item.label
                    }
                })
            }

            if(variant.images){
                v.images = variant.images.map((image) => {
                    return image.path
                });
            }else{
                v.images = []
            }
            return v;
        });

        if(this.props.initialValues.variantsIndexes.length === 0){
            data.price = values.price;
            data.quantity = values.quantity;
            data.sku = values.sku;
        }

        data.notes = values.notes;
        data.handling_time = values.handling_time;
        data.pcondition = values.pcondition || 'new';
        data.free_shipping = values.free_shipping ? 1 : 0;

        data.free_shipping_jerusalem = values.free_shipping_jerusalem ? 1 : 0;
        data.free_shipping_48 = values.free_shipping_48 ? 1 : 0;
        data.free_shipping_gaza = values.free_shipping_gaza ? 1 : 0;
        data.shipping_by_seller = values.shipping_by_seller ? 1 : 0;
        data.shipping_delivery_option = values.shipping_delivery_option
        data.pickup_from = values.pickup_from


        return FixFormValues(data);
    }
    onSubmit(values) {

        values = this.getValues(values);

        let piecesPrice = 0;

        let valid = true;


        if(values.variants && values.variants.length ){
            piecesPrice = []
            values.variants.forEach((item,i) => {
                if(item.price < 100){
                    piecesPrice.push({
                        index:i,
                        price:item.price,
                        label:item.items.map((item) => {
                            return GetEntityAttribute(item,'title')
                        }).join(" ")
                    });
                    valid = false;
                }
            })
        }else{
            if(values.price < 100){
                valid = false;
                piecesPrice = values.price
            }
        }

        if(valid){
            this.sendCreateRequest(values);
        }else{
            this.setState({
                requiresPiecesUpdate:true,
                piecesPrice:piecesPrice
            })
        }
    }


    sendCreateRequest(data){

        this.props.toggleFormActionStatus(true);

        axios.post(
            `${Config.api()}product/create/${this.props.auth.business.id}/${this.props.match.params.categoryId}`,
            data,
            {
                withCredentials: Config.withCredentials()
            }
        ).then((response) => {
            if (!response.data.success) {
                if(response.data && response.data.message){
                    NotificationManager.error(response.data.message);
                }else{
                    NotificationManager.error(locale.get('an_error_occurred_while_creating_your_product'));
                }
            } else {
                NotificationManager.success(locale.get('sell_product_added_successfully'), GetEntityAttribute(data,'title'));
                this.props.navigateTo(`/${this.props.match.params.businessSlug}/manage/`);
            }
            this.props.toggleFormActionStatus(false);
        }).catch((error) => {
            if(error.response.status === 401) {
                this.props.requiresReLogin();
            }else{
                if(error.response.data && error.response.data.message){
                    NotificationManager.error(error.response.data.message);
                }else{
                    NotificationManager.error(locale.get('an_error_occurred_while_creating_your_product'));
                }
            }
            this.props.toggleFormActionStatus(false);
        });
    }


    render() {

        const disabled = false;
        let subView = <WithoutVariantFields
            selector={this.props.selector}
            handling_times={this.props.productSpecs.seller.handling_times}
            addresses={this.props.productSpecs.seller.addresses}
            only_primary={this.props.initialValues.variantsIndexes.length > 0}
            product_conditions={this.props.productSpecs.seller.product_conditions || this.props.productSpecs.product_conditions || []}
            shipping_delivery_options_list={this.props.productSpecs.seller.shipping_delivery_options_list || this.props.productSpecs.shipping_delivery_options_list || []}
            disabled={disabled}/>

        return (
            <Loader completed={this.props.productSpecs.fetched}>


                {
                    this.state.requiresPiecesUpdate &&
                    <PiecesModal
                        price={this.state.piecesPrice}
                        onSubmit={this.onSubmitPieces}
                        onRefuse={this.onRefusePieces}
                        onClose={() => {this.setState({requiresPiecesUpdate:false})}} />
                }



                <div className="panel-1">
                    <form className="form-horizontal" onSubmit={this.props.handleSubmit(this.onSubmit.bind(this)) }>
                        <div className="panel-1--head bg-white">
                            {locale.get('create_product')}
                        </div>
                        <div className="panel-1--breadcrumb">
                            <Breadcrumb items={this.props.productSpecs.breadcrumb}
                                        prefix={locale.get('product_breadcrumb_prefix')}/>
                        </div>

                        <div className="panel-1--body">
                            <div className="inner-content-width">
                                <div className="tooltip-field" data-scroll-hide={true} data-event="click focusin focus"
                                     data-event-off="focusout" data-tip='' data-tooltip-id='tooltip-title_ar'
                                     data-iscapture="false" data-place="left" data-effect="solid" data-multiline="true">
                                    <Field
                                        type="text"
                                        name="title_ar"
                                        id="title_ar"
                                        disabled={disabled}
                                        component={ProductInput}
                                        className="form-control"
                                        label={locale.get('product_title_ar')}
                                        placeholder={locale.get('product_title_ar')}
                                        field={{}}
                                        required="required"/>

                                    <ReactTooltip
                                        id='tooltip-title_ar'>{locale.get('product_tooltip_title')}</ReactTooltip>
                                </div>
                                <div className="tooltip-field"
                                     data-scroll-hide={true}
                                     data-tooltip-id='tooltip-description_ar'
                                     data-tip=''
                                     data-iscapture={false}
                                     data-place="left"
                                     data-html="true"
                                     data-effect="solid"
                                     data-multiline="true">
                                    <Field
                                        type="textarea"
                                        name="description_ar"
                                        disabled={disabled}
                                        id="description_ar"
                                        component={ProductInput}
                                        className="form-control"
                                        label={locale.get('product_description_ar')}
                                        placeholder={locale.get('product_description_ar')}
                                        field={{data_type: "textarea"}}/>
                                    <ReactTooltip

                                        id='tooltip-description_ar'>
                                        <div dangerouslySetInnerHTML={{__html: locale.get('product_tooltip_description_ar')}} />

                                    </ReactTooltip>
                                </div>

                                <div className="clearfix"></div>

                                { this.props.initialValues.variantsIndexes.length === 0 &&
                                <FieldArray component={DropZone} disabled={disabled} name="images" label={locale.get('product_images')}/> }

                                <div className="clearfix"></div>
                            </div>
                        </div>
                        <div className="clearfix"></div>

                        <ProductAttributesWizard attributes={this.props.productSpecs.attributes}
                                                 subView={subView}
                                                 action="create"
                                                 disabled={disabled}
                                                 withVariants={true}
                                                 values={this.props.formValues}
                                                 selector={this.props.selector}
                                                 containerProps={this.props}/>
                        <Field
                            type="hidden"
                            name="at_least_one_variant"
                            id="at_least_one_variant"
                            component="input"
                            className="form-control" />

                        <div className="clearfix"></div>


                    </form>
                </div>
            </Loader>
        );
    }

    onChange(field, value) {
        if (field.is_variant) {
            this.props.requireVariantUpdate(true);
        }
    }
}

// Maps state from store to props
const mapStateToProps = (state, ownProps) => {
    let variants = state.variants;

    if (!variants && state.product.variantsIndexes.length) {
        variants = selector(state, ...state.product.variantsIndexes);
        if (Array.isArray(variants)) {
            let tmpVariants = {};
            tmpVariants[state.product.variantsIndexes[0]] = variants
            variants = tmpVariants;
        }
    }


    if(state.productForm.seller.addresses.length === 1){
        state.product.pickup_from = state.productForm.seller.addresses[0].id
    }


    return {
        auth: state.auth,
        productSpecs: state.productForm,
        initialValues: state.product,
        withVariants: true,
        variants: variants,
        formActions: state.formActions,
        productAttributesValues: state.productAttributesWizard,
        selector: (...field) => selector(state, ...field),
        errors: formErrors('productForm')(state),
        formValues: getFormValues('productForm')(state),
    }
};

// Maps actions to props
const mapDispatchToProps = (dispatch) => {
    return {
        fetchProductForm: (categoryId) => dispatch(productFormActions.fetch(categoryId)),
        removeVariants: (index) => dispatch(arrayRemoveAll('productForm', 'variants')),
        changeVariants: (fields) => dispatch(arrayPush('productForm', 'variants', fields)),
        requireVariantUpdate: (bool) => dispatch(productFormActions.requireVariantUpdate(bool)),
        redirect: (url) => dispatch(routerPush(url)),
        toggleFormActionStatus: (status) => dispatch({
            type: 'FORM_SUBMITTING_CHANGE_STATUS',
            status: status
        }),
        throwErrors: (errors) => {
            let flattenedErrors = flattenObject(errors);

            dispatch(touchForm('productForm', ...Object.keys(flattenedErrors)))

            dispatch(stopAsyncValidation('productForm', errors))
        },
        requiresReLogin: ()=>dispatch(authActions.requiresRelogin())
    }
};

Product = reduxForm({
    form: formName,
    enableReinitialize:true,
    touchOnChange: true,
    onChange: (values, dispatch, props) => {
        if (props.productSpecs.requireVariantUpdate === true) {
            let options = [];
            props.initialValues.variantsIndexes.forEach((item) => {
                if (!props.variants[item] || props.variants[item].length === 0) {
                    return false;
                }
                options = [...options, props.variants[item]];
            });

            if (options.length > 0) {
                let products = CartesianProduct(options);
                let matchedIndexes = [];
                let fields = [];

                products.forEach((product) => {

                    let variantToUpdate;
                    let lastMatch = 0;
                    values.variants.forEach((variant, variantIndex) => {
                        let totalMatches = 0;
                        variant.items.forEach(function (variantItem) {
                            product.forEach((productItem) => {
                                if (productItem.value === variantItem.id && productItem.field === variantItem.field) {
                                    totalMatches += 1;
                                }
                            });
                        });
                        if (totalMatches === options.length || totalMatches === options.length - 1) {
                            if (totalMatches > lastMatch && matchedIndexes.indexOf(variantIndex) === -1) {
                                variantToUpdate = variant;
                                lastMatch = totalMatches;
                                matchedIndexes.push(variantIndex);
                            }
                        }
                    });

                    let productItems = product.map((item) => {
                        if (item.id) {
                            return item;
                        } else {
                            return {
                                id: item.value,
                                name: item.label,
                                field: item.field,
                                group_id: item.group_id,
                                attribute_id: item.attribute_id,
                                label: item.label,
                            }
                        }
                    });
                    if (variantToUpdate) {
                        fields.push({...variantToUpdate, items: productItems});
                    } else {
                        fields.push({items: productItems, is_active: true});
                    }
                });
                props.requireVariantUpdate(false);
                props.removeVariants();
                fields.forEach(function (field) {
                    props.changeVariants(field);
                });
            } else {
                props.removeVariants();
            }
        }
    },
    validate: formValidation,
    onSubmitFail:(errors) => {
        console.log(errors)
        publishErrors(errors)
    }
})(Product);

export default connect(mapStateToProps, mapDispatchToProps)(Product);
